// PDFButton.jsx
import React from 'react'
import { Button } from 'reactstrap'
import { useResumenTables } from '../../context/ResumenTablesContext'


const PDFButton = () => {
  const { isSaveDisabled, isFetching } = useResumenTables()
  const loading = isFetching
  const disabled = isSaveDisabled || loading

 
  const className = disabled
    ? 'pdf-button pdf-button--disabled'
    : 'pdf-button'

  return (
    <Button
      className={className}
      disabled={disabled}
    >
      {loading ? 'Generando PDF...' : 'Descargar PDF'}
    </Button>
  )
}

export default PDFButton
